export enum ReportsUrlParams {
    dashboardId = 'dashboardId',
    reportInfo = 'reportInfo',
    studyId = 'studyId',
}
